<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="save" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_save($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-order_group"
                     *ngIf="!fieldsets.order_group.hidden && !fieldsets.order_group.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.order_group.collapsible }">
                    <div *ngIf="!fieldsets.order_group.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.order_group.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.order_group.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.order_group.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.order_group.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.order_group.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.order_group.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-lookup_code" *ngIf="!fields.lookup_code.hidden && !fields.lookup_code.removed" 
                            class="field-container standard {{fields.lookup_code.invalid ? 'invalid' : ''}} {{fields.lookup_code.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.lookup_code.styles.style"
                            [ngClass]="fields.lookup_code.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.lookup_code.label + (fields.lookup_code.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.lookup_code.label}}<span *ngIf="fields.lookup_code.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="lookup_code"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.lookup_code.control.readOnly || fields.lookup_code.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.lookup_code.control.placeholder}}"
                                [ngStyle]="fields.lookup_code.control.styles.style"
                                [ngClass]="fields.lookup_code.control.styles.classes"
                                [matTooltip]="fields.lookup_code.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.lookup_code.invalid">
                          <ng-container *ngFor="let error of fields.lookup_code.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-warehouse_id" *ngIf="!fields.warehouse_id.hidden && !fields.warehouse_id.removed" 
                            class="field-container standard {{fields.warehouse_id.invalid ? 'invalid' : ''}} {{fields.warehouse_id.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.warehouse_id.styles.style"
                            [ngClass]="fields.warehouse_id.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.warehouse_id.label + (fields.warehouse_id.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.warehouse_id.label}}<span *ngIf="fields.warehouse_id.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Manufacturing-warehouses_dd_single 
                            data-cy="selector"
                            [type]="fields.warehouse_id.control.type"
                            formControlName="warehouse_id"
                            (displayTextChange)="fields.warehouse_id.control.displayText=$event"
                            [placeholder]="fields.warehouse_id.control.placeholder"
                            [styles]="fields.warehouse_id.control.styles"
                            [tooltip]="fields.warehouse_id.control.tooltip"
                        >
                        </Manufacturing-warehouses_dd_single>
                        <ng-container *ngIf="fields.warehouse_id.invalid">
                          <ng-container *ngFor="let error of fields.warehouse_id.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-owner_id" *ngIf="!fields.owner_id.hidden && !fields.owner_id.removed" 
                            class="field-container standard {{fields.owner_id.invalid ? 'invalid' : ''}} {{fields.owner_id.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.owner_id.styles.style"
                            [ngClass]="fields.owner_id.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.owner_id.label + (fields.owner_id.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.owner_id.label}}<span *ngIf="fields.owner_id.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Manufacturing-owners_dd_single 
                            data-cy="selector"
                            [type]="fields.owner_id.control.type"
                            formControlName="owner_id"
                            (displayTextChange)="fields.owner_id.control.displayText=$event"
                            [placeholder]="fields.owner_id.control.placeholder"
                            [styles]="fields.owner_id.control.styles"
                            [tooltip]="fields.owner_id.control.tooltip"
                        >
                        </Manufacturing-owners_dd_single>
                        <ng-container *ngIf="fields.owner_id.invalid">
                          <ng-container *ngFor="let error of fields.owner_id.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-project_id" *ngIf="!fields.project_id.hidden && !fields.project_id.removed" 
                            class="field-container standard {{fields.project_id.invalid ? 'invalid' : ''}} {{fields.project_id.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.project_id.styles.style"
                            [ngClass]="fields.project_id.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.project_id.label + (fields.project_id.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.project_id.label}}<span *ngIf="fields.project_id.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Manufacturing-projects_dd_single 
                            data-cy="selector"
                            [type]="fields.project_id.control.type"
                            formControlName="project_id"
                            (displayTextChange)="fields.project_id.control.displayText=$event"
                            [placeholder]="fields.project_id.control.placeholder"
                            [styles]="fields.project_id.control.styles"
                            [tooltip]="fields.project_id.control.tooltip"
                          [status_id]="$fields_project_id_selector_inParams_status_id"
                          [owner_id]="$fields_project_id_selector_inParams_owner_id"
                        >
                        </Manufacturing-projects_dd_single>
                        <ng-container *ngIf="fields.project_id.invalid">
                          <ng-container *ngFor="let error of fields.project_id.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-staging_location_id" *ngIf="!fields.staging_location_id.hidden && !fields.staging_location_id.removed" 
                            class="field-container standard {{fields.staging_location_id.invalid ? 'invalid' : ''}} {{fields.staging_location_id.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.staging_location_id.styles.style"
                            [ngClass]="fields.staging_location_id.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.staging_location_id.label + (fields.staging_location_id.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.staging_location_id.label}}<span *ngIf="fields.staging_location_id.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <FootprintManager-manufacturing_staging_locations_dd_single 
                            data-cy="selector"
                            [type]="fields.staging_location_id.control.type"
                            formControlName="staging_location_id"
                            (displayTextChange)="fields.staging_location_id.control.displayText=$event"
                            [placeholder]="fields.staging_location_id.control.placeholder"
                            [styles]="fields.staging_location_id.control.styles"
                            [tooltip]="fields.staging_location_id.control.tooltip"
                          [warehouse_id]="$fields_staging_location_id_selector_inParams_warehouse_id"
                          [project_id]="$fields_staging_location_id_selector_inParams_project_id"
                        >
                        </FootprintManager-manufacturing_staging_locations_dd_single>
                        <ng-container *ngIf="fields.staging_location_id.invalid">
                          <ng-container *ngFor="let error of fields.staging_location_id.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-output_location_id" *ngIf="!fields.output_location_id.hidden && !fields.output_location_id.removed" 
                            class="field-container standard {{fields.output_location_id.invalid ? 'invalid' : ''}} {{fields.output_location_id.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.output_location_id.styles.style"
                            [ngClass]="fields.output_location_id.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.output_location_id.label + (fields.output_location_id.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.output_location_id.label}}<span *ngIf="fields.output_location_id.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <FootprintManager-manufacturing_output_locations_dd_single 
                            data-cy="selector"
                            [type]="fields.output_location_id.control.type"
                            formControlName="output_location_id"
                            (displayTextChange)="fields.output_location_id.control.displayText=$event"
                            [placeholder]="fields.output_location_id.control.placeholder"
                            [styles]="fields.output_location_id.control.styles"
                            [tooltip]="fields.output_location_id.control.tooltip"
                          [warehouse_ids]="$fields_output_location_id_selector_inParams_warehouse_ids"
                          [project_id]="$fields_output_location_id_selector_inParams_project_id"
                        >
                        </FootprintManager-manufacturing_output_locations_dd_single>
                        <ng-container *ngIf="fields.output_location_id.invalid">
                          <ng-container *ngFor="let error of fields.output_location_id.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-estimated_start" *ngIf="!fields.estimated_start.hidden && !fields.estimated_start.removed" 
                            class="field-container standard {{fields.estimated_start.invalid ? 'invalid' : ''}} {{fields.estimated_start.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.estimated_start.styles.style"
                            [ngClass]="fields.estimated_start.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.estimated_start.label + (fields.estimated_start.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.estimated_start.label}}<span *ngIf="fields.estimated_start.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <app-datebox 
                            data-cy="dateBox"
                            formControlName="estimated_start"
                            [format]="fields.estimated_start.control.format"
                            [mode]="fields.estimated_start.control.mode"
                            [ngStyle]="fields.estimated_start.control.styles.style"
                            [ngClass]="fields.estimated_start.control.styles.classes"
                            [tooltip]="fields.estimated_start.control.tooltip">
                        </app-datebox>
                        <ng-container *ngIf="fields.estimated_start.invalid">
                          <ng-container *ngFor="let error of fields.estimated_start.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-estimated_end" *ngIf="!fields.estimated_end.hidden && !fields.estimated_end.removed" 
                            class="field-container standard {{fields.estimated_end.invalid ? 'invalid' : ''}} {{fields.estimated_end.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.estimated_end.styles.style"
                            [ngClass]="fields.estimated_end.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.estimated_end.label + (fields.estimated_end.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.estimated_end.label}}<span *ngIf="fields.estimated_end.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <app-datebox 
                            data-cy="dateBox"
                            formControlName="estimated_end"
                            [format]="fields.estimated_end.control.format"
                            [mode]="fields.estimated_end.control.mode"
                            [ngStyle]="fields.estimated_end.control.styles.style"
                            [ngClass]="fields.estimated_end.control.styles.classes"
                            [tooltip]="fields.estimated_end.control.tooltip">
                        </app-datebox>
                        <ng-container *ngIf="fields.estimated_end.invalid">
                          <ng-container *ngFor="let error of fields.estimated_end.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.order_group.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-notes_group"
                     *ngIf="!fieldsets.notes_group.hidden && !fieldsets.notes_group.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.notes_group.collapsible }">
                    <div *ngIf="!fieldsets.notes_group.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.notes_group.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.notes_group.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.notes_group.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.notes_group.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.notes_group.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.notes_group.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-notes" *ngIf="!fields.notes.hidden && !fields.notes.removed" 
                            class="field-container full {{fields.notes.invalid ? 'invalid' : ''}} {{fields.notes.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.notes.styles.style"
                            [ngClass]="fields.notes.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.notes.label + (fields.notes.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.notes.label}}<span *ngIf="fields.notes.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <textarea cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" data-cy="textBox-multi" formControlName="notes"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.notes.control.readOnly || fields.notes.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.notes.control.placeholder}}"
                                [ngStyle]="fields.notes.control.styles.style"
                                [ngClass]="fields.notes.control.styles.classes"
                                [matTooltip]="fields.notes.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> </textarea>
                        <ng-container *ngIf="fields.notes.invalid">
                          <ng-container *ngFor="let error of fields.notes.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.notes_group.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>